import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import { BiErrorCircle } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import { CustomSelect } from 'src/components';
import Button from 'src/components/button';
import { fetchMyCurrency } from 'src/redux/action/currency.action';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

interface IProps {
  detailData?: any;
  loading?: boolean;
}

const FORM_VALIDATION = Yup.object().shape({
  categoryId: Yup.string().required('Category Name is required')
});

const CurrencySettings: React.FC<IProps> = () => {
  const dispatch = useDispatch();
  const {currencyData, myCurrencyData} = useSelector(({ currencyData }: RootState) => currencyData);
  const currencyOptions = currencyData?.map((item: any) => {
        return {
          name: item?.name,
          id: item?.code,
        };
      })
    ?? [];

  const intValues = {
    categoryId: myCurrencyData?.code ?? '',
  };
  
  const handleSubmit = async (val: any) => {
    try {
      const payload = {
        currencyCode: val.categoryId
      }
      await Service.put('/settings/currency', payload);
      toastAlert('success', `Currency is successfully updated`);
      dispatch(fetchMyCurrency() as any);
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };
  
  if (!(currencyData?.length > 0 && myCurrencyData)) return null;
  return (
    <Formik
      enableReinitialize={true}
      initialValues={intValues}
      validateOnMount
      validationSchema={FORM_VALIDATION}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, values, isValid }) => (
        <Form className="mt-5 w-full">
          <div>
            {' '}
           <Field
              name="categoryId"
              className="mt-3"
              options={currencyOptions ?? []}
              component={CustomSelect}
              defaultValue={currencyOptions?.find((opt: any) => opt.id === myCurrencyData?.code)?.name}
              isMulti={false}
              label="Currency"
              placeholder={'select a currency'}
            />
          </div>

          <div className="relative mt-10">
            <BiErrorCircle
              size={17}
              color="#fff"
              className="absolute top-2 mx-2"
            />
            <ErrorMessage
              component="div"
              name={'categoryId'}
              className="bg-warning bg-opacity-80 text-pure-white mt-1 text-xs inline-block px-7 py-1 rounded-sm"
            />
          </div>

          <div className="flex items-center justify-end mt-14">
            <Button
              text={'Update'}
              variant="primary"
              isSubmitting={isSubmitting}
              isValid={isValid}
              type="submit"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CurrencySettings;
